import { Button } from '@metadevprofile/ui/web';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';
import { PageHelmet } from '@/common/components/page-helmet';

export function RouteErrorBoundary() {
  const { t } = useTranslation('common');
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <>
      <PageHelmet title={t('routeError.title')} />
      <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
        <h1 className="text-2xl font-semibold text-foreground">{t('routeError.title')}</h1>
        <p className="mt-2 text-muted">{t('routeError.description')}</p>
        <Button onPress={handleRetry} className="mt-8">
          {t('routeError.retry')}
        </Button>
      </div>
    </>
  );
}
